import { preload } from "../../utils/Preload";
import { EditorialModule } from "./EditorialModule";

export class ImageModule extends EditorialModule {
  constructor(element: HTMLElement) {
    super(element);
  }
}
